export default __webpack_public_path__ + "static/media/aboutimg8.68145d83.webp";